<template>
  <div id="header" :class="[
    { 'white-text': modeType === '1' },
    { 'dark-bg-text': modeType === '2' && opacity < 0.5 },
    { 'dark-bg-text-scroll': modeType === '2' && opacity >= 0.5 },
    { 'black-text': opacity >= 0.5 },
    { 'is-solid': opacity >= 0.5 },
  ]" :style="{ backgroundColor: `rgba(255, 255, 255, ${modeType === '2' ? opacity : opacity})` }">
    <div class="bar-box white-box" @mouseenter="showBg" @mouseleave="hideBg">
      <div class="logo-box">
        <router-link to="/index" class="logo-link" id="home">
          <img v-if="modeType === '1' && opacity <= 0.5" class="logo logo-b" style="width: 150px;height: 36px;"
            src="@/assets/sk-logo-1.png" />
          <img v-else-if="modeType === '2' && opacity <= 0.5" class="logo logo-b" style="width: 108px;height: 36px;"
            src="@/assets/sk-logo-transparent.png" />
          <img v-else class="logo logo-b" style="width: 150px;height: 36px;" src="@/assets/sk-logo-1.png" />
        </router-link>

        <ul class="top-bar">
          <li v-for="item in navItems" :key="item.label">
            <!-- 无下拉的一级项 -->
            <router-link v-if="!item.megaMenu" class="first-menu" :to="item.to">{{ item.label }}</router-link>

            <!-- 有下拉的一级项：标题本身不可点，只作为 hover 触发区 -->
            <template v-else>
              <span class="first-menu">
                {{ item.label }}
                <LucideIcon class="menu-caret" name="chevron-down" :size="16" />
              </span>

              <div class="sub-menu">
                <div class="sub-menu-inner">
                  <!-- 机器人 / 关于我们：条目横向铺开，无列标题 -->
                  <div v-if="item.megaMenu.layout === 'horizontal'" class="sub-menu-grid is-horizontal"
                    :style="{ gridTemplateColumns: `repeat(${item.megaMenu.columns[0].items.length}, 1fr)` }">
                    <router-link v-for="link in item.megaMenu.columns[0].items" :key="link.label"
                      class="menu-link is-horizontal" :to="link.to">
                      <span class="menu-link-label">
                        {{ link.label }}
                        <LucideIcon class="menu-link-arrow" name="arrow-right" :size="14" />
                      </span>
                      <span v-if="link.desc" class="menu-link-desc">{{ link.desc }}</span>
                    </router-link>
                  </div>

                  <!-- 其他：按列分组 -->
                  <div v-else class="sub-menu-grid"
                    :style="{ gridTemplateColumns: `repeat(${item.megaMenu.columns.length}, 1fr)` }">
                    <div class="menu-col" v-for="col in item.megaMenu.columns" :key="col.title">
                      <h3 class="menu-col-title">
                        <LucideIcon v-if="col.icon" :name="col.icon" :size="16" />
                        {{ col.title }}
                      </h3>
                      <router-link v-for="link in col.items" :key="link.label" class="menu-link" :to="link.to">
                        <span class="menu-link-label">
                          {{ link.label }}
                          <LucideIcon class="menu-link-arrow" name="arrow-right" :size="14" />
                        </span>
                        <span v-if="link.desc" class="menu-link-desc">{{ link.desc }}</span>
                      </router-link>
                    </div>

                    <div v-if="item.megaMenu.footerBtn" class="menu-footer">
                      <router-link class="menu-footer-btn" :to="item.megaMenu.footerBtn.to">
                        {{ item.megaMenu.footerBtn.label }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>

    <div class="fixed-right" :class="{ 'show-back-top': showBackTop }" ref="fixedRight">
      <transition name="fade">
        <div class="wechat-btn" @click="openContact('PC')">
          <div class="wechat">
            <div class="text">联系我们</div>
          </div>
          <div class="bg"></div>
        </div>
      </transition>
      <transition name="fade">
        <div class="back-top" @click="scrollToTop" v-if="showBackTop">
          <img src="@/assets/about/back-top.png" alt="" />
          <div class="text">返回顶部</div>
        </div>
      </transition>
    </div>
    <ContactUs ref="contactUs" @closeModal="closeModal" :isModalVisible="isModalVisible" :infoSources="infoSources" v-if="isModalVisible" />
  </div>
</template>
<script>
import ContactUs from "@/components/ContactUs";
import LucideIcon from "@/components/LucideIcon.vue";

// ========== 导航数据 ==========
// 结构对齐 projects-vue 的 SiteHeader.vue：
//   { label, to } 或 { label, megaMenu: { layout, columns: [{ title, icon, items }] } }
// layout === 'horizontal' 时条目横向铺开、不显示列标题（机器人 / 关于我们）。
// to 一律交给 <router-link>，不再用 <a @click="$router.push">，
// 这样中键新标签页、右键复制链接都能正常工作。
const navItems = [
  { label: '首页', to: '/index' },
  {
    label: '智能体',
    megaMenu: {
      columns: [
        {
          title: '企业智能体',
          icon: 'bot',
          items: [
            { label: '千橙AI超级店长', desc: '零售门店AI经营助手', to: { name: 'qcSuper' } },
            { label: 'LeapoAI', desc: '企业级AI智能体平台', to: { name: 'leapoAI' } }, // leapoAI
            { label: '九词NineToken', desc: 'AI内容创作平台', to: { name: 'nineToken' } }, // nineToken
          ],
        },
        {
          title: '企业级数据服务',
          icon: 'database',
          items: [
            { label: '千智数据平台', desc: '让数据驱动智能，整合全链路数据能力', to: { name: 'aiDataService' } },
          ],
        },
        {
          title: '存算大模型一体机',
          icon: 'server',
          items: [
            { label: '玄武系列', desc: '为智算中心与企业级AI应用提供澎湃算力', to: { name: 'aiServer', query: { series: 'xuanwu' } } },
            { label: '钟山系列', desc: '预装完整AI软件栈，即插即用', to: { name: 'aiServer', query: { series: 'zhongshan' } } },
          ],
        },
      ],
    },
  },
  { label: 'AI效果营销', to: { name: 'market' } },
  {
    label: '云服务',
    megaMenu: {
      columns: [
        {
          title: '零售云',
          icon: 'shopping-cart',
          items: [
            { label: '千橙收银系统', desc: 'AI驱动半自动/自助收单', to: { name: 'retailMall' } },
            { label: '千橙门店O2O系统', desc: 'AI赋能门店O2O一体化管理', to: { name: 'onlineErp' } },
            { label: '千橙连锁系统', desc: 'AI赋能多业态连锁管理', to: { name: 'onlineAndOfflineIntegration' } },
          ],
        },
        {
          title: '分销云',
          icon: 'network',
          items: [
            { label: '千橙S2B2C系统', desc: 'AI全链路闭环交易', to: { name: 'integration' } },
            { label: '千橙B2B系统', desc: 'AI驱动多层级分销', to: { name: 'b2bChannel' } },
          ],
        },
        {
          title: '电商云',
          icon: 'shopping-bag',
          items: [
            { label: '千橙微商城', desc: 'AI社群电商小程序', to: { name: 'digitalSystem' } },
            { label: '汇团团社群营销系统', desc: 'AI社群团购小程序', to: { name: 'scrmProduct' } },
          ],
        },
        {
          title: '会员云',
          icon: 'users',
          items: [
            { label: '千橙会员营销系统', desc: '基于AI的会员SCRM', to: { name: 'marketing' } },
          ],
        },
        {
          title: '直播云',
          icon: 'video',
          items: [
            { label: '千橙Qlive直播', desc: 'AI赋能直播系统', to: { name: 'live' } },
          ],
        },
      ],
      footerBtn: { label: '产品体验下载', to: { name: 'QcDownload' } },
    },
  },
  {
    label: '机器人',
    megaMenu: {
      layout: 'horizontal',
      columns: [
        {
          items: [
            { label: 'LM200', desc: 'AI 智能零售巡检机器人', to: { name: 'lm200' } },
            { label: 'LM202', desc: 'AI 智能零售巡检机器人', to: { name: 'lm202' } },
            { label: 'LM203', desc: 'AI 智能安保巡逻机器人', to: { name: 'lm203' } },
            { label: 'LM211', desc: 'AI 智能零售机器人', to: { name: 'lm211' } },
          ],
        },
      ],
    },
  },
  { label: '千橙AI合作伙伴计划', to: { name: 'coPlan' } },
  {
    label: '关于我们',
    megaMenu: {
      layout: 'horizontal',
      columns: [
        {
          items: [
            { label: '新闻动态', desc: '实时传递公司动态，聚焦行业前沿资讯', to: { name: 'news' } },
            { label: '公司简介', desc: '深耕智能科技领域，赋能企业数字化转型', to: { name: 'about' } },
          ],
        },
      ],
    },
  },
];

export default {
  props: {
    modeType: {
      type: String,
      default: "",
    },
  },
  components: {
    ContactUs,
    LucideIcon,
  },
  data() {
    return {
      navItems,
      opacity: 0,
      showBackTop: false,
      isModalVisible: false,
      infoSources: '官网首页',
    };
  },
  created() {
    window.addEventListener("scroll", this.scrollFn);
    // 监听全局事件，用于子页面调用打开 ContactUs 弹窗
    this.$root.$on('openContactUs', this.openContactFromChild);
  },
  methods: {
    // 供子页面调用打开 ContactUs 弹窗
    openContactFromChild(infoSources) {
      this.infoSources = infoSources || '官网产品页';
      this.isModalVisible = true;
    },
    openContact(infoSources) {
      this.infoSources = infoSources || '官网首页';
      this.isModalVisible = true;
    },
    showBg() {
      this.opacity = 1;
    },
    hideBg() {
      this.opacity = 0;
      this.scrollFn();
    },
    scrollFn() {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop === 0) {
        this.opacity = 0;
      }
      if (scrollTop > 0 && scrollTop < 200) {
        this.opacity = this.opacity + 0.1;
      }
      if (scrollTop > 100) {
        this.opacity = 1;
      }
      this.handleScroll();
    },
    handleScroll() {
      const screenHeight = window.innerHeight;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= screenHeight) {
        this.showBackTop = true;
      } else {
        this.showBackTop = false;
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollFn);
    this.$root.$off('openContactUs', this.openContactFromChild);
  },
};
</script>
<style lang="less" scoped>
@import '~@/components/siteVars.less';

#header {
  height: @site-header-h;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: background-color 0.3s, box-shadow 0.3s, backdrop-filter 0.3s;

  // 滚动或 hover 后：白底 + 毛玻璃 + 细阴影（对齐 SiteHeader 的
  // bg-white/95 backdrop-blur-md shadow-sm）
  &.is-solid {
    backdrop-filter: blur(12px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
}

.logo-box {
  .site-container();
  height: @site-header-h;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin: 0;
}

.logo-box .logo {
  cursor: pointer;
  vertical-align: middle;
}

.first-menu {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 8px;
  color: @site-ink;
  cursor: default;
  transition: background-color 0.2s, color 0.2s;
}

// 可点击的一级项（router-link 渲染成 a）才给手型
a.first-menu {
  cursor: pointer;
}

.menu-caret {
  transition: transform 0.2s;
}

.bar-box .top-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0 !important;

  li {
    display: flex;
    align-items: center;
    height: @site-header-h;

    // 下拉面板：白底、顶部细线、大阴影，高度由内容决定
    .sub-menu {
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      background: #ffffff;
      border-top: 1px solid @site-gray-100;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    }

    .sub-menu-inner {
      .site-container();
      padding-top: 32px;
      padding-bottom: 32px;
    }

    .sub-menu-grid {
      display: grid;
      gap: 32px;

      &.is-horizontal {
        gap: 24px;
      }
    }

    .menu-col-title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0 0 16px;
      padding: 0 12px 8px;
      font-size: 16px;
      font-weight: 400;
      color: @site-ink;
      line-height: 24px;
      text-align: left;
      border-bottom: 1px solid @site-gray-100;
    }

    .menu-link {
      display: block;
      padding: 10px 12px;
      border-radius: 8px;
      text-align: left;
      transition: background-color 0.2s;

      & + .menu-link {
        margin-top: 12px;
      }

      &:hover {
        background: @site-hover-bg;
      }

      &.is-horizontal {
        padding: 12px 16px;

        & + .menu-link {
          margin-top: 0;
        }

        .menu-link-label {
          font-weight: 500;
        }

        .menu-link-desc {
          font-size: 13px;
          margin-top: 4px;
        }
      }

      .menu-link-label {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 15px;
        font-weight: 600;
        color: @site-ink;
        line-height: 20px;
      }

      .menu-link-arrow {
        opacity: 0;
        transition: opacity 0.2s, transform 0.2s;
      }

      &:hover .menu-link-arrow {
        opacity: 1;
        transform: translateX(2px);
      }

      .menu-link-desc {
        display: block;
        margin-top: 6px;
        font-size: 14px;
        color: @site-gray-500;
        line-height: 20px;
        transition: color 0.2s;
      }

      &:hover .menu-link-desc {
        color: @site-ink;
      }
    }

    .menu-footer {
      grid-column: 1 / -1;
      margin-top: 8px;
      padding-top: 16px;
      border-top: 1px solid @site-gray-100;
      text-align: center;
    }

    .menu-footer-btn {
      display: inline-block;
      padding: 8px 24px;
      background: @site-blue;
      color: #ffffff;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.2s, transform 0.2s;

      &:hover {
        background: @site-blue-dark;
        transform: translateY(-1px);
      }
    }
  }

  li:hover {
    .sub-menu {
      display: block;
    }

    .first-menu {
      color: @site-blue;
      background: @site-gray-50;
    }

    .menu-caret {
      transform: rotate(180deg);
    }
  }
}

.white-text .first-menu,
.dark-bg-text-scroll .first-menu,
.black-text .first-menu {
  color: @site-ink;
  opacity: 1;
}

.dark-bg-text .first-menu {
  color: #ffffff;
  opacity: 1;
}

// modeType="2" 在页面顶部是透明底压深色 banner，
// 此时 hover 底色不能用浅灰（白字会糊掉），改用半透明白。
.dark-bg-text .top-bar li:hover .first-menu {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
}

.fixed-right {
  position: fixed;
  right: 10px;
  bottom: 100px;
  width: 100px;
  transform: translateY(-50%);
  z-index: 1000;
  transition: all 0.3s;

  &.show-contact {
    opacity: 1;
  }

  &.show-back-top {
    opacity: 1;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .wechat-btn {
    position: relative;
    width: 100px;

    height: 100px;

    .bg {
      background-image: url("~@/assets/about/loading.png");
      background-size: 100% 100px;
      background-repeat: no-repeat;
      background-position: center;
      animation: spin 2s linear infinite;
      width: 100px;
      height: 100px;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .wechat {
      width: 100px;
      height: 100px;
      cursor: pointer;
      background-image: url("~@/assets/about/contact.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      z-index: 11;

      .text {
        position: absolute;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 14px;
        text-align: center;
        bottom: 7px;
        left: 0;
        width: 100%;
      }
    }
  }

  .back-top {
    cursor: pointer;
    width: 70px;
    height: 46px;
    background: linear-gradient(180deg, #374c8f 0%, #1b2f72 100%);
    border-radius: 4px;
    margin: 10px auto;
    text-align: center;

    &.fade-enter-active,
    &.fade-leave-active {
      transition: opacity 0.3s;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }

    img {
      width: 16px;
      height: 16px;
      margin-bottom: 2px;
      margin-top: 7px;
    }

    .text {
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 14px;
    }
  }
}
</style>
